import $ from 'jquery';

class CountrySelector {
  constructor(el) {
    this.opened = false
    this.drawer = el;
    this.hamburger = document.querySelector('.country-selector-toggle')

    this.hamburger.addEventListener('click', e => {
      this.toggle()
    });
    window.addEventListener('main-menu-toggle', (e) => {
      const mainMenu = e.detail;
      if (mainMenu.open) {
        this.close();
        this.hamburger.classList.add('hide');
      } else {
        this.hamburger.classList.remove('hide');
      }
    });
    $(document).on('click', (e) => {
      // console.dir($(e.target));
      if (!$(e.target).is('#block-countryselectormenu') && $(e.target).parents('#block-countryselectormenu').length === 0 && !$(e.target).is('.country-selector-toggle')) {
        this.close();
      }
    });
  }

  open() {
    this.hamburger.classList.add('active');
    this.drawer.classList.add('active');
    this.opened = true
    // emit event to let other menus know this menu is opening
    const event = new CustomEvent('country-selector-toggle', {
      detail: {
        open: true
      }
    });
    window.dispatchEvent(event);
    
  }

  close() {
    this.hamburger.classList.remove('active');
    this.drawer.classList.remove('active');
    this.opened = false
    // emit event to let other menus know this menu is closing
    const event = new CustomEvent('country-selector-toggle', {
      detail: {
        open: false
      }
    });
    window.dispatchEvent(event);
  }

  toggle() {
    if (this.opened) {
      this.close()
    } else {
      this.open()
    }
  }
}

export default CountrySelector


// WEBPACK FOOTER //
// ./js/classes/country-selector.class.js